import { getTokenSilently } from 'packages/lib/auth';
import { loadConfig } from 'packages/lib/config';

const env = loadConfig();

export const getDefaultHeaders = async (): Promise<Record<string, string>> => {
  return {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${(await getTokenSilently())?.accessToken}`,
  };
};

export type APIBackend =
  | 'logMiner'
  | 'annotations'
  | 'trainingPlatformOld'
  | 'trainingPlatformEx'
  | 'drivelogs'
  | 'jobMetrics'
  | 'blobFrames' // https://confluence.ci.motional.com/confluence/display/BACK/Blob+Frames+API#BlobFramesAPI-GettingSupportedChannelandBlobTypeschannel-summary-api
  | 'techMetrics'
  | 'dtb'
  | 'airflow'
  | 'userMetrics'
  | 'taskHistory'
  | 'annotationsAppApi'
  | 'omnitag'
  | 'polarisHost';

const backends = {
  logMiner: env.apiHosts.logminerHost,
  trainingPlatformOld: env.apiHosts.trainingPlatformHostOld,
  trainingPlatformEx: env.apiHosts.trainingPlatformHostEx,
  annotations: env.apiHosts.annotationsHost,
  drivelogs: env.apiHosts.drivelogsHost,
  jobMetrics: env.apiHosts.jobMetricsHost,
  blobFrames: env.apiHosts.blobFramesHost,
  techMetrics: env.apiHosts.techMetricsHost,
  dtb: env.apiHosts.dtbHost,
  airflow: env.apiHosts.airflowHost,
  userMetrics: env.apiHosts.userMetricsHost,
  taskHistory: env.apiHosts.taskHistoryHost,
  annotationsAppApi: env.apiHosts.annotationsAppApi,
  omnitag: env.apiHosts.omnitagHost,
  polarisHost: env.apiHosts.polarisHost,
};

export function getBaseUrlForBackend(backend: APIBackend | undefined): string {
  if (!backend) return env.apiHosts.annotationsHost;
  return backends[backend] ?? env.apiHosts.annotationsHost;
}
